export default __webpack_public_path__ + "static/media/carynIcon.4c378b10.jpg";